import { render, staticRenderFns } from "./ViewReportIcon.vue?vue&type=template&id=ec2f37d2&"
import script from "./ViewReportIcon.vue?vue&type=script&lang=js&"
export * from "./ViewReportIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports